<script setup lang="ts">

import {Dialog} from "quasar";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import ChatDialog from "@/components/navBar/chat/ChatDialog.vue";
import {storeToRefs} from "pinia";
import {useLoginInfoStore} from "@/stores/loginInfo.ts";
import Translator from "@/utils/common/Translator.ts";

let {chatMessagesCounts} = storeToRefs(useLoginInfoStore());

function toggleDialog() {
  Dialog.create({
    component: ChatDialog,
    componentProps: {}
  })
}
</script>

<template>
  <div class="tw-flex tw-justify-center">
    <div
      class="tw-relative focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-white/75 hover:tw-cursor-pointer"
      @click="toggleDialog" :title="Translator.translateId('chats')">
      <NamaIcon default-icon="nm-chat" class="tw-size-6 compact:tw-size-[22px] ultra:tw-size-5"/>
      <span v-text="chatMessagesCounts > 99 ? '+99' : chatMessagesCounts"
            class="tw-absolute tw-bg-red-600 tw-rounded-[25%] tw-text-sm ultra:tw-text-xs tw-p-1 ultra:tw-p-0.5 tw-text-namaFontColor-dark tw--top-1/3 tw-left-1/2 tw-leading-[10px]"
            v-if="chatMessagesCounts > 0"/>
    </div>
  </div>
</template>

<style scoped>

</style>
